import { render, staticRenderFns } from "./modularChild8.vue?vue&type=template&id=252662b0&scoped=true"
import script from "./modularChild8.vue?vue&type=script&lang=js"
export * from "./modularChild8.vue?vue&type=script&lang=js"
import style0 from "./modularChild8.vue?vue&type=style&index=0&id=252662b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252662b0",
  null
  
)

export default component.exports